import { useEffect, useState } from 'react';

interface PaginationPros {
	totalNumberOfPages: number;
	currentPage: number;
	paginationPerPage: number;
	onPaginationChange: (currentPage: number) => void;
}

const Pagination = ({
	totalNumberOfPages,
	currentPage = 1,
	paginationPerPage = 5,
	onPaginationChange
}: PaginationPros) => {
	const [activePageNumber, setActivePageNumber] = useState(currentPage);
	const pageNumbers = [];

	useEffect(() => {
		setActivePageNumber(currentPage);
	}, [currentPage]);

	const handlePagination = (event: any) => {
		event.preventDefault();
		const pageNumber = parseInt(event.target.id);
		if (event.target.id !== '') {
			onPaginationChange(pageNumber);
			setActivePageNumber(pageNumber);
		}
	};

	for (let i = 1; i <= Math.ceil(totalNumberOfPages / paginationPerPage); i++) {
		pageNumbers.push(i);
	}

	if (pageNumbers.length === 0) {
		return null;
	}

	return (
		<ul className="pagination">
			<li className="page-item">
				<span
					className={`page-link ${activePageNumber > 1 ? '' : 'hide'}`}
					tabIndex={0}
					role="button"
					aria-label="Previous"
					onClick={handlePagination}>
					<span id={(activePageNumber - 1).toString()} className="icon-arrow-left item-icon"></span>
					<span className="sr-only">Previous</span>
				</span>
			</li>

			{pageNumbers.map((pageNumber: number) => (
				<li className="page-item" key={pageNumber}>
					<a
						key={pageNumber}
						href="/"
						onClick={handlePagination}
						className={`page-link ${activePageNumber === pageNumber ? 'page-select' : ''}`}
						id={pageNumber.toString()}
						aria-label={'Pagination' + pageNumber}
						tabIndex={activePageNumber === pageNumber ? -1 : undefined}>
						{pageNumber}
					</a>
				</li>
			))}

			<li className="page-item">
				<span
					className={`page-link ${
						activePageNumber >= Math.ceil(totalNumberOfPages / paginationPerPage) ? 'hide' : ''
					}`}
					tabIndex={0}
					role="button"
					aria-label="Next"
					onClick={handlePagination}>
					<span
						id={(activePageNumber + 1).toString()}
						className="icon-arrow-right item-icon"></span>
					<span className="sr-only">Next</span>
				</span>
			</li>
		</ul>
	);
};

export default Pagination;
